module.exports = __webpack_public_path__ + "static/media/09.3f057b2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/09.jpg
// module id = 270
// module chunks = 0